import { render } from "./requestLists.vue?vue&type=template&id=4806fe5c&scoped=true"
import script from "./requestLists.vue?vue&type=script&lang=js"
export * from "./requestLists.vue?vue&type=script&lang=js"

import "./requestLists.vue?vue&type=style&index=0&id=4806fe5c&scoped=true&lang=scss"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4806fe5c"]])

export default __exports__